import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventsRepository } from '../repositories/events.repository';
import { CityModel } from '../models/city.model';

@Injectable({
  providedIn: 'root',
})
export class CitiesService {
  constructor(private eventsRepository: EventsRepository) {}

  load(): Observable<CityModel[]> {
    return this.eventsRepository.getCities();
  }
}
